


























































































import { Component, Prop, Vue } from 'vue-property-decorator';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';
import { UnitSystem } from '@/interfaces/units';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import { IAcOverlayDesignImperial, IAcOverlayDesignMetric } from '@/modules/design/interfaces/acOverlay';

@Component({
  components: {
    PxDropdown,
    PxNumberInput,
    QuickHelp,
  },
})

export default class CoreQuestions extends Vue {
  @Prop() scenario!: IAcOverlayDesignImperial | IAcOverlayDesignMetric;

  @Prop({ default: null }) validationObject!: any;

  yesNoOptions = [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' },
  ];

  crackTypeOptions = [
    { value: 'Top-Down Only', text: 'Top-Down Only' },
    { value: 'Entire Depth', text: 'Entire Depth' },
    { value: 'Both', text: 'Both' },
  ];

  get depthUnit() {
    return this.unitSystemIsImperial ? 'in' : 'cm';
  }

  get unitSystemIsImperial() {
    return this.scenario.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.$emit('sync');
  }
}
